import { render, staticRenderFns } from "./grupoListList.vue?vue&type=template&id=baa3dd42&scoped=true"
import script from "./grupoListList.vue?vue&type=script&lang=js"
export * from "./grupoListList.vue?vue&type=script&lang=js"
import style0 from "./grupoListList.vue?vue&type=style&index=0&id=baa3dd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa3dd42",
  null
  
)

export default component.exports